import { createAction, props } from '@ngrx/store';

export const retryAllFailedActions = createAction(
  '[Core:Retry] Retry Failed action'
);

export const retrySpecificActionTypes = createAction(
  '[Core:Retry] Retry Failed action types',
  props<{ types: string[] }>()
);

export const clearRetryFailedActions = createAction(
  '[Core:Retry] Clear Retry failed actions'
);
